import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const DeleteConfirmationModal = ({ show, onHide, onConfirm, message }) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirmar Eliminación</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {message || '¿Estás seguro de que deseas eliminar este ítem? Esta acción no se puede deshacer.'}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} data-testid="modal-cancel-button">Cancelar</Button>
                <Button variant="danger" onClick={onConfirm} data-testid="modal-confirm-button">Eliminar</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteConfirmationModal;
